import Event from "./Event";
import { apiURL } from "../helpers/url";

class Search extends Event {
  constructor() {
    super();
    this.apiURL = apiURL();
    this.search = {};
    this.promises = {
      fetchSearch: null
    };
    this.AbortControllers = {
      fetchSearch: []
    };
  }

  // Creating a global instance
  static createInstance() {
    return new this();
  }

  abortFetch(name) {
    Object.values(this.AbortControllers[name]).forEach(controller => controller.abort());
    this.AbortControllers[name] = [];
  }

  /**
   * Fetch Search item
   *
   * Search returns pending Promise if API request is pending
   *
   * @returns {Promise} Promise object with status and data
   */
  fetchSearch(type, keyword) {
    this.publish("itemsFetching");

    // Ha folyamatban van egy másik kérés, megszakítjuk azt
    this.abortFetch("fetchSearch");
    let controller = new AbortController();
    this.AbortControllers.fetchSearch.push(controller);

    // Speciális karakterek escape-elése
    const escapedKeyword = this.removeSpecialCharacters(keyword);

    // API hívás
    this.promises.fetchSearch = fetch(
        `${this.apiURL}/search?${type}=${encodeURIComponent(escapedKeyword)}`,
        {
            signal: controller.signal
        }
    )
        .then(response => {
            return response.text().then(text => {
                return {
                    status: response.status,
                    content: text
                };
            });
        })
        .then(response => {
            let content = response.status < 300 ? JSON.parse(response.content) : null;

            if (content) {
                this.search = content;
                this.publish("itemsFetched");
            }
            this.promises.fetchSearch = null;

            return {
                status: response.status,
                content: content
            };
        })
        .catch(error => {
            this.promises.fetchSearch = null;
            return {
                status: 600,
                error: error
            };
        });

    return this.promises.fetchSearch;
  }

  // Speciális karakterek escape-elésére szolgáló metódus
  removeSpecialCharacters(keyword) {
    return keyword.replace(/[+\-=&|><!(){}[\]^"~*?:\\/]/g, '');
  }

}

export default Search;
